import React from "react";
import Head from "./Head/Head";

const offers = () => {
  return (
    <>
      <Head />
      <div style={{padding:'10rem'}}>offers</div>
    </>
  );
};

export default offers;
